import React, { Component, Fragment } from 'react'
import { Query, Mutation } from 'react-apollo'

import { USER_QUERY, SELF_QUERY } from '../../queries'
import { EDIT_USER, UPDATE_PERMISSIONS } from '../../mutations'

import TabBreadcrumb from '../../components/TabBreadcrumb/'
import BackLink from '../../components/BackLink/'
import Form from '../../components/Form/'
import Loader from '../../components/Loader/'
import Error from '../../components/Error/'

import withHeaderFooter from '../../wrapper/withHeaderFooter'

import { Container } from '../../styles/defaults.js'
import { MiniContainer, Title } from './styles.js'
import helpers from '../../helpers'

class EditMember extends Component {
  constructor(props) {
    super(props)
    this.state = {
      tabOne: true,
      currentTab: 'Algemeen'
    }
  }

  showRights() {
    this.setState({
      tabOne: false,
      currentTab: 'Rechtenprofielen'
    })
  }

  showGeneral() {
    this.setState({
      tabOne: true,
      currentTab: 'Algemeen'
    })
  }

  branchOptions(branches, setBranches) {
    return branches.map(branch => {
      let value = branches.length < 2 ? true : false

      let set = setBranches.filter(setBranch => setBranch.id === branch.id).length > 0

      value = set ? true : value
      return { label: branch.name, name: branch.id, value, type: 'checkbox' }
    })
  }

  render() {
    const { tabOne, currentTab } = this.state

    return (
      <Query query={SELF_QUERY}>
        {({ loading, error, data }) => {
          if (loading) return <Loader fixed from='25%' to='50%' />
          if (error) return <Error error='de gebruikersgegevens' />
          const { self } = data

          let editUser = self.permissions.includes('EDIT_USER') || self.role === 'MANAGER'
          if (editUser) {
            return (
              <Query query={USER_QUERY} variables={{ id: this.props.match.params.id }}>
                {({ data, loading, error }) => {
                  if (loading) return <Loader fixed from='50%' to='100%' />
                  if (error) return <Error error='de medewerker gegevens' />
                  const user = data.user

                  Object.keys(user).map((key, index) => {
                    if (user[key] === null) {
                      user[key] = ''
                    }
                    return null
                  })

                  const branches = this.branchOptions(self.branches, user.branches)
                  let genderOptions = [{ value: 'MALE', label: 'Man' }, { value: 'FEMALE', label: 'Vrouw' }]
                  let generalFormFields = [
                    { name: 'gender', label: 'Geslacht', value: user.gender, type: 'select', options: genderOptions },
                    {
                      name: 'firstName',
                      label: 'Voornaam*',
                      value: user.firstName,
                      type: 'text',
                      required: 'required'
                    },
                    {
                      name: 'insertion',
                      label: 'Tussenvoegsel',
                      value: user.insertion,
                      type: 'select',
                      options: helpers.getInsertions()
                    },
                    {
                      name: 'lastName',
                      label: 'Achternaam*',
                      value: user.lastName,
                      type: 'text',
                      required: 'required'
                    },
                    { name: 'email', label: 'E-mailadres*', value: user.email, type: 'email', required: 'required' },
                    { name: 'phone', label: 'Telefoonnummer*', value: user.phone, type: 'tel', required: 'required' },
                    { name: 'altPhone', label: 'Alternatief telefoonnummer', value: user.altPhone, type: 'tel' }
                  ]

                  generalFormFields = [{ type: 'title', name: 'Filialen:' }].concat(branches.concat(generalFormFields))

                  let permissionsFormFields = [
                    { name: "Pagina's", type: 'title' },
                    { name: 'VIEW_ASSORTIMENT', label: 'Assortiment bekijken', value: '', type: 'checkbox' },
                    { name: 'VIEW_MACHINES', label: 'Machines bekijken', value: '', type: 'checkbox' },
                    { name: 'VIEW_AGENDA', label: 'Agenda bekijken', value: '', type: 'checkbox' },
                    { name: 'VIEW_NOTIFICATIONS', label: 'Meldingen bekijken', value: '', type: 'checkbox' },
                    { name: 'Bedrijf', type: 'title' },
                    { name: 'VIEW_BRANCH', label: 'Bedrijfsgegevens inzien', value: '', type: 'checkbox' },
                    { name: 'EDIT_BRANCH', label: 'Bedrijfsgegevens bewerken', value: '', type: 'checkbox' },
                    { name: 'Bestellen', type: 'title' },
                    { name: 'VIEW_ORDERS', label: 'Bestellijsten inzien', value: '', type: 'checkbox' },
                    { name: 'VIEW_PRICES', label: 'Prijzen inzien', value: '', type: 'checkbox' },
                    {
                      name: 'EDIT_ORDER',
                      label: 'Bestelling bewerken (producten toevoegen / verwijderen)',
                      value: '',
                      type: 'checkbox'
                    },
                    { name: 'SEND_ORDER', label: 'Bestelling verzenden', value: '', type: 'checkbox' },
                    { name: 'Orderhistorie', type: 'title' },
                    { name: 'VIEW_OLD_ORDER', label: 'Orderhistorie bekijken', value: '', type: 'checkbox' },
                    { name: 'REPEAT_OLD_ORDER', label: 'Order herhalen', value: '', type: 'checkbox' },
                    { name: 'Facturen', type: 'title' },
                    { name: 'VIEW_INVOICES', label: 'Facturen bekijken', value: '', type: 'checkbox' },
                    { name: 'Technische gegevens', type: 'title' },
                    { name: 'VIEW_TECH', label: 'Technische gegevens bekijken', value: '', type: 'checkbox' },
                    { name: 'Profielgegevens', type: 'title' },
                    { name: 'EDIT_PROFILE', label: 'Profielgegevens wijzigen', value: '', type: 'checkbox' },
                    { name: 'Medewerkers', type: 'title' },
                    { name: 'VIEW_USERS', label: 'Medewerkers bekijken', value: '', type: 'checkbox' },
                    { name: 'ADD_USER', label: 'Medewerker toevoegen', value: '', type: 'checkbox' },
                    { name: 'EDIT_USER', label: 'Medewerker wijzigen', value: '', type: 'checkbox' },
                    { name: 'DELETE_USER', label: 'Medewerker verwijderen', value: '', type: 'checkbox' },
                    { name: 'Storing melden', type: 'title' },
                    { name: 'REPORT_ERROR', label: 'Storing melden', value: '', type: 'checkbox' },
                    { name: '', type: 'title' }
                  ]

                  permissionsFormFields.forEach(field => {
                    field.value = user.permissions.includes(field.name)
                  })

                  return (
                    <Fragment>
                      <TabBreadcrumb
                        parent='Medewerkers'
                        parentUrl='/medewerkers'
                        title={currentTab}
                        one='Algemeen'
                        oneShort='Algemeen'
                        two='Rechtenprofielen'
                        twoShort='Rechtenprofielen'
                        onClickOne={this.showGeneral.bind(this)}
                        onClickTwo={this.showRights.bind(this)}
                      />

                      <BackLink title='Terug naar medewerkers' link='/medewerkers' contained />

                      <Container>
                        <Fragment>
                          {tabOne ? (
                            <MiniContainer>
                              <Title>Algemeen</Title>
                              <Mutation
                                mutation={EDIT_USER}
                                variables={{ id: this.props.match.params.id }}
                                update={(store, { data: { updateUser } }) => {
                                  let data = store.readQuery({
                                    query: USER_QUERY,
                                    variables: { id: this.props.match.params.id }
                                  })

                                  Object.keys(data.user).map((key, index) => {
                                    if (data.user[key] !== updateUser[key]) {
                                      data.user[key] = updateUser[key]
                                    }
                                    return null
                                  })

                                  store.writeQuery({
                                    query: USER_QUERY,
                                    data
                                  })
                                }}
                              >
                                {(editUser, { data, loading, error }) => (
                                  <Form
                                    fields={generalFormFields}
                                    submitText='Opslaan'
                                    userId={this.props.match.params.id}
                                    branches={true}
                                    onSubmitForm={editUser}
                                    data={data}
                                    loading={loading}
                                    error={error}
                                    userImage
                                    gender={user.gender}
                                  />
                                )}
                              </Mutation>
                            </MiniContainer>
                          ) : null}
                          {!tabOne ? (
                            <MiniContainer>
                              <Title>Rechtenprofiel</Title>
                              <Mutation
                                mutation={UPDATE_PERMISSIONS}
                                variables={{ id: this.props.match.params.id }}
                                update={(store, { data: { updatePermissions } }) => {
                                  let data = store.readQuery({
                                    query: USER_QUERY,
                                    variables: { id: this.props.match.params.id }
                                  })

                                  Object.keys(data.user).map((key, index) => {
                                    if (data.user[key] !== updatePermissions[key]) {
                                      data.user[key] = updatePermissions[key]
                                    }
                                    return null
                                  })

                                  store.writeQuery({
                                    query: USER_QUERY,
                                    data
                                  })
                                }}
                              >
                                {(updatePermissions, { data, loading, error }) => (
                                  <Form
                                    fields={permissionsFormFields}
                                    submitText='Opslaan'
                                    userId={this.props.match.params.id}
                                    permissions={true}
                                    onSubmitForm={e => {
                                      let permissions = []
                                      Object.keys(e.variables.data).forEach((key, index) => {
                                        if (e.variables.data[key] === true) {
                                          permissions.push(key)
                                        }
                                      })
                                      updatePermissions({
                                        variables: { data: { id: this.props.match.params.id, permissions } }
                                      })
                                    }}
                                    data={data}
                                    loading={loading}
                                    error={error}
                                  />
                                )}
                              </Mutation>
                            </MiniContainer>
                          ) : null}
                        </Fragment>
                      </Container>
                    </Fragment>
                  )
                }}
              </Query>
            )
          } else {
            return (
              <Fragment>
                <BackLink title='Terug naar medewerkers' link='/medewerkers' contained />
                <Container style={{ textAlign: 'center' }} mt mb>
                  Onvoldoende rechten om deze gebruiker aan te passen
                </Container>
              </Fragment>
            )
          }
        }}
      </Query>
    )
  }
}

export default withHeaderFooter(EditMember, '', 'black')



// WEBPACK FOOTER //
// ./src/views/EditMember/index.js